import Page from "./Page";

export default class Home extends Page {
	constructor() {
		super();


		this.videoContainer = document.getElementById( 'header_video_container' );
		this.btnPlay        = document.querySelectorAll( '.btn-play-header-video' );
		this.btnClose       = document.getElementById( 'btn_close_header_video' );
		this.body           = document.querySelector( 'body' );

		this.bindEvents();
	}

	bindEvents() {
		Array.from( this.btnPlay ).forEach( ( btn ) => {
			btn.addEventListener( 'click', e => {
				this.openPlayer( e.target );
			} );
		} )

		this.btnClose.addEventListener( 'click', e => {
			this.closePlayer();
		} );
	}


	openPlayer( clicked ) {

		const videoUrl = clicked?.dataset?.video ?? '';

		if ( videoUrl === '' ) {
			alert( 'No video information. Please add one in the CMS.' );
			return;
		}

		this.videoContainer.innerHTML = '<video id="video_player" src="' + clicked.dataset.video + '" controls playsinline autoplay></video>';
		const player                  = new Plyr( '#video_player' );
		player.on( 'ended', event => {

			this.closePlayer();
		} );
		Page.addClass( this.body, 'is-video-visible' );
	}

	closePlayer() {
		this.videoContainer.innerHTML = '';
		Page.removeClass( this.body, 'is-video-visible' );
	}

}